import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { detailMatcher, detailTicketsMatcher } from './shared/app-routing-url-matchers';

const routes: Routes = [
  {
    matcher: detailMatcher,
    loadChildren: () =>
      import('./containers/detail/detail.module').then((m) => m.DetailModule),
  },
  {
    matcher: detailTicketsMatcher,
    loadChildren: () =>
      import('./containers/tickets/tickets.module').then((m) => m.TicketsModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./containers/error/error.module').then((m) => m.ErrorModule),
  },
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forRoot(routes, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
